export const LOG_EVENT_TYPE_STRING_EXPECTED = 'log(eventType, eventProperties): expected string for eventType';
export const LOG_EVENT_PROPERTIES_OBJECT_EXPECTED = 'log(eventType, eventProperties): expected object for eventProperties';
export const LOG_EVENT_SIGN_IN_VIEWED = "Sign In - viewed";
export const LOG_EVENT_SIGN_IN_CLICKED = "Sign In - sign_in_clicked";
export const LOG_EVENT_SIGN_IN_SSO_GO_CLICKED = "Sign In - sso_go_clicked";
export const LOG_EVENT_SIGN_IN_OTHER_SIGN_IN_LINK_CLICKED = "Sign In - other_sign_in_link_clicked";
